module.exports = __webpack_public_path__ + "static/media/img 3.3f5188da.png";